import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "@/router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import VueMask from "@devindex/vue-mask";

//imports for app initialization
import KeycloakService from "@/core/services/KeycloakService";
import ApiServiceCustom from "./core/services/ApiServiceCustom";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import obterMenus from "@/utils/obterMenus";
import { createPinia } from "pinia";

import piniaPluginPersistedstate from "pinia-plugin-persistedstate"; // add para persistir os dados
import { useUsuarioStore } from "@/store/usuarioStore";

import "@/core/plugins/prismjs";
import "bootstrap";
import { aplicarTemaEduxme, isEduxme } from "@/core/helpers/tema";

if (isEduxme()) {
  aplicarTemaEduxme();
}
import globalComponent from "./globalComponent";

const initializeApp = async () => {
  try {
    await KeycloakService.init();
    await obterMenus();
    const app = createApp(App);
    const pinia = createPinia();
    pinia.use(piniaPluginPersistedstate); // add para persistir os dados
    app.use(store);
    app.use(router);
    app.use(ElementPlus);
    app.use(VueMask);
    app.use(i18n);
    app.use(pinia);

    globalComponent(app);

    ApiServiceCustom.init(app);
    initApexCharts(app);
    initInlineSvg(app);
    initVeeValidate();

    app.mount("#app");
    const usuarioStore = useUsuarioStore();
    usuarioStore.limparDados();
    await usuarioStore.carregarDadosUsuario();
  } catch (error) {
    console.error("Erro ao inicializar o aplicativo:", error);
  }
};

initializeApp();
